import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { getTrip } from "redux/actions/UserTrip";
import {
  getTripCheckout,
} from "redux/actions/UserCustomerTrip";
import CommonForm from "./CommonForm";
import { dateFormateForFareScreen, truncateComment } from "utils/utils";
import { tripEnumObject } from "utils/enumObject";
import {
  FacilitiesData,
  fareData,
  onewayRulePoint,
  rulePoints,
} from "./FacilitiesData";
import calender from "assets/images/calender.svg";
import clock from "assets/images/clock.svg";
import pickup from "assets/images/pickUp.svg";
import drop from "assets/images/drop.svg";
import editIcon from "assets/images/editIcon.svg";
import wifi from "assets/images/wifi.svg";
import myrideIcon from "assets/images/myrideActive.svg";
import charger from "assets/images/charger.svg";
import snacks from "assets/images/snacks.svg";
import newspaper from "assets/images/newspaper.svg";
import water from "assets/images/water.svg";
import FareBreakUp from "./FareBreakUp";

function ComfirmPay() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openDialog, setOpenDialog] = useState(false);
  const merchantKey = process.env.REACT_APP_PAYU_MERCHANT_KEY;
  const paths = JSON.parse(sessionStorage.getItem("paths"));
  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const pickupLatLng = JSON.parse(sessionStorage.getItem("pickupLatLng"));
  const type = searchParams.get("type");
  const status =
    type === tripEnumObject?.rental
      ? "Rental"
      : type === tripEnumObject?.airport
      ? "Airport"
      : type === tripEnumObject?.outStationRound
      ? "Outstation"
      : "Ride";
  //added this to check for two screen , until payu works In future we will remove
  const { state } = useLocation();
  const dispatch = useDispatch();
  const rideStatus = state?.rideStatus;
  const hashValue = useSelector(
    (state) => state?.userPaymentHash?.userPaymentHash?.data?.sha
  );
  const loading = useSelector((state) => state?.userPaymentHash?.loading);
  const cancelReasonData = useSelector(
    (state) => state?.userCancelReason?.userCancelReason?.data
  );
  const tripData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const tripCheckoutData = useSelector(
    (state) => state?.userTripCheckout?.userTripCheckout?.data?.tripDetails
  );
  const couponApplyDate = useSelector(
    (state) => state?.userCouponApply?.userCouponApply?.data
  );
  const couponRentalApplyDate = useSelector(
    (state) => state?.userRentalCouponApply?.userCouponRental?.data
  );
  const sessionPickup = sessionStorage.getItem("pickup");
  const sessionDrop = sessionStorage.getItem("drop");
  const dateOne = sessionStorage.getItem("date");
  const endDateOne = sessionStorage.getItem("endDate");
  const decodedPoints = JSON.parse(sessionStorage.getItem("decodedPoints"));
  const rideInclusion = JSON.parse(sessionStorage.getItem("rideInclusion"));
 

  // const formData = [
  //   {
  //     type: "checkbox",
  //     content: "I accept the ",
  //     link: "Terms & Conditions",
  //   },
  // ];
  const onClickEditBtn = () => {
    localStorage.setItem("isEdit", true);
    localStorage.removeItem("trip");
    navigate("/ride?type=" + type);
  };
  const redirect = () => {
    navigate("/ride?type=" + type);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOnError = (e, facilityName) => {
    let replacementImage;
    switch (facilityName) {
      case "pepper spray":
        replacementImage = wifi;
        break;
      case "Snack":
        replacementImage = snacks;
        break;
      case "Charger":
        replacementImage = charger;
        break;
      case "Newspaper":
        replacementImage = newspaper;
        break;
      case "Water Bottel":
        replacementImage = water;
        break;
      default:
        replacementImage = wifi;
    }
    e.target.src = replacementImage;
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const ride = useSelector((state) => state?.userTrip?.userTrip?.data);
  const handleCancelClose = () => {
    setOpenDialog(!openDialog);
  };
  const polyline = state?.tripCheckout?.polyLine?.coordinates?.[0];
  const polylineData = polyline?.map((item) => {
    return { lat: item[0], lng: item[1] };
  });
  const pathData =
    (polylineData?.length > 0 && polylineData) || (paths?.length > 0 && paths);

  const onConfirmPayBtn = (data, code) => {
    const customerDetails = JSON.parse(sessionStorage.getItem("userDetails"));
    let tripData = {};
    if (type === tripEnumObject?.rental) {
      tripData = {
        type: params?.type,
        rateId: params?.rateId,
        rateCardTypeId: params?.rateCardTypeId,
        sourceLocation: pickupLatLng?.[0]?.lat
          ? [pickupLatLng?.[0]?.lat, pickupLatLng?.[0]?.lng]
          : [params?.sourceLat, params?.sourceLng],
        sourceAddress:
          JSON.parse(sessionPickup)?.description ||
          JSON.parse(sessionPickup)?.formatted_address,
        scheduledTime: dateOne,
        customerDetails,
        placardText: sessionStorage.getItem("placardText") || "",
      };
    } else {
      tripData = {
        type: params?.type,
        distance: params?.distance,
        rateId: params?.rateId,
        riderId: "",
        sourceLocation: [params?.sourceLat, params?.sourceLng],
        destinationLocation: [params?.destinationLat, params?.destinationLng],
        eta: params?.eta,
        googleResponse: {},
        polyLine: decodedPoints,
        scheduledTime: dateOne,
        returnTime: endDateOne,
        sourceAddress:
          JSON.parse(sessionPickup)?.description ||
          JSON.parse(sessionPickup)?.formatted_address,
        destinationAddress:
          JSON.parse(sessionDrop)?.description ||
          JSON.parse(sessionDrop)?.formatted_address ||
          (JSON.parse(sessionDrop)?.vicinity &&
            JSON.parse(sessionDrop)?.name +
              ", " +
              JSON.parse(sessionDrop)?.vicinity) ||
          JSON.parse(sessionDrop)?.name,
          customerDetails,
          placardText: sessionStorage.getItem("placardText") || "",
      };
    }

    if (
      couponApplyDate?.data?.[0]?.id ||
      couponRentalApplyDate?.data?.[0]?.id
    ) {
      tripData = {
        ...tripData,
        couponId:
          couponApplyDate?.data?.[0]?.couponId ||
          couponRentalApplyDate?.data?.[0]?.couponId,
      };
    }
    sessionStorage.removeItem("needPlacard");
    sessionStorage.removeItem("placardText");
    dispatch(getTripCheckout(tripData, navigate));
  };
  useEffect(() => {
    if (rideStatus) {
      // dispatch(getCancelReason());
      dispatch(
        getTrip({
          id: state?.tripCheckout?.tripDetails?.id || state?.tripCheckout?.id,
        })
      );
    }
  }, [rideStatus]);

  const tripPrice =
    sessionStorage?.getItem("tripPrice")?.length > 0 &&
    JSON.parse(sessionStorage?.getItem("tripPrice"));
  const cabFacilities =
    tripPrice?.Facilities || tripData?.facilities || 
     tripPrice?.MasterCarType?.Facilities ||
    tripPrice?.masterCarType?.Facilities;
  const baseFarePerKM =
    (state?.tripCheckout?.amount ||
      state?.tripCheckout?.price ||
      tripPrice?.baseFare || tripPrice?.totalAmount) /
    (state?.tripCheckout?.tripDetails?.actualDistance ||
      state?.tripCheckout?.actualDistance ||
      tripPrice?.distance);

      return (
        <div className="max-h-screen bg-white w-full px-0 lg:w-[68%] lg:px-12">
          <div className="flex flex-col space-y-6">
            {/* Header Section */}
            <div className="flex items-start justify-start">
              <h2 className="text-[20px] font-semibold text-[#0f538d]">
                {"Confirm Booking"}
              </h2>
            </div>
      
            {/* Pickup Location */}
            <div className="flex items-center justify-start gap-3">
              <div className="w-8 flex-shrink-0">
                <img src={pickup} alt="pickup" />
              </div>
              <div className="flex-1">
                <p className="text-sm">
                  <Tooltip
                    title={
                      state?.tripCheckout?.tripDetails?.sourceAddress ||
                      state?.tripCheckout?.sourceAddress ||
                      JSON.parse(sessionPickup)?.description ||
                      JSON.parse(sessionPickup)?.formatted_address ||
                      ride?.sourceAddress
                    }
                    placement="bottom"
                  >
                    {truncateComment(
                      state?.tripCheckout?.tripDetails?.sourceAddress ||
                        state?.tripCheckout?.sourceAddress ||
                        JSON.parse(sessionPickup)?.description ||
                        JSON.parse(sessionPickup)?.formatted_address ||
                        ride?.sourceAddress,
                      70
                    )}
                  </Tooltip>
                </p>
              </div>
              {!rideStatus && (
                <div className="flex-shrink-0">
                  <button
                    onClick={onClickEditBtn}
                    className="p-2 hover:bg-gray-100 rounded transition-colors"
                  >
                    <img src={editIcon} alt="editIcon" className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
      
            {/* Drop Location */}
            {type !== tripEnumObject?.rental && (
              <div className="flex items-center justify-start gap-3">
                <div className="w-8 flex-shrink-0">
                  <img src={drop} alt="drop" />
                </div>
                <div className="flex-1">
                  <p className="text-sm">
                    <Tooltip
                      title={
                        state?.tripCheckout?.tripDetails?.destinationAddress ||
                        ride?.destinationAddress ||
                        state?.tripCheckout?.destinationAddress ||
                        JSON.parse(sessionDrop)?.description
                      }
                      placement="bottom"
                    >
                      {truncateComment(
                        (state?.tripCheckout?.tripDetails?.destinationAddress ||
                          ride?.destinationAddress ||
                          state?.tripCheckout?.destinationAddress ||
                          JSON.parse(sessionDrop)?.description ||
                          JSON.parse(sessionDrop)?.name) ||
                          (JSON.parse(sessionDrop)?.vicinity &&
                            (JSON.parse(sessionDrop)?.name +
                              ", " +
                              JSON.parse(sessionDrop)?.vicinity)),
                        90
                      )}
                    </Tooltip>
                  </p>
                </div>
                {!rideStatus && (
                  <div className="flex-shrink-0">
                    <button
                      onClick={onClickEditBtn}
                      className="p-2 hover:bg-gray-100 rounded transition-colors"
                    >
                      <img src={editIcon} alt="editIcon" className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
            )}
      
            {/* Trip Status Section */}
            {type !== tripEnumObject?.outStationRound ? (
              <div className="flex items-center justify-start gap-3">
                <div className="w-8 flex-shrink-0">
                  <img src={myrideIcon} alt="trip" />
                </div>
                <div className="flex-1 flex flex-col sm:flex-row sm:items-center sm:gap-4">
                  <p className="text-blue-600 font-medium">{status}</p>
                  {!rideStatus && (
                    <p className="font-medium">
                      {dateFormateForFareScreen(
                        state?.tripCheckout?.tripDetails?.scheduledTime ||
                          state?.tripCheckout?.scheduledTime ||
                          dateOne,
                        "calendar"
                      )}
                    </p>
                  )}
                </div>
                {!rideStatus && (
                  <div className="flex-shrink-0">
                    <button
                      onClick={onClickEditBtn}
                      className="p-2 hover:bg-gray-100 rounded transition-colors"
                    >
                      <img src={editIcon} alt="editIcon" className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <div className="w-8 flex-shrink-0">
                  <img src={myrideIcon} alt="trip" />
                </div>
                <div className="flex-1 flex flex-col sm:flex-row sm:gap-4">
                  <p className="text-blue-600 font-medium">{status}</p>
                  <p className="font-medium">
                    {dateFormateForFareScreen(
                      state?.tripCheckout?.tripDetails?.scheduledTime ||
                        state?.tripCheckout?.scheduledTime ||
                        dateOne,
                      "calendar"
                    )}
                  </p>
                  <p className="font-medium">
                    {dateFormateForFareScreen(
                      state?.tripCheckout?.tripDetails?.returnTime ||
                        state?.tripCheckout?.returnTime ||
                        endDateOne,
                      "calendar"
                    )}
                  </p>
                </div>
                {!rideStatus && (
                  <div className="flex-shrink-0">
                    <button
                      onClick={onClickEditBtn}
                      className="p-2 hover:bg-gray-100 rounded transition-colors"
                    >
                      <img src={editIcon} alt="editIcon" className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
            )}
      
            {/* Start Time Section - Only if rideStatus */}
            {rideStatus && (
              <div className="pt-6 border-t border-dashed border-gray-300 flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <img src={calender} alt="calendar" />
                  <p className="text-black font-semibold">Start Time</p>
                </div>
                <div className="flex items-center gap-4 pl-8">
                  <p className="text-sm text-black">
                    {dateFormateForFareScreen(
                      state?.tripCheckout?.tripDetails?.scheduledTime ||
                        state?.tripCheckout?.scheduledTime,
                      "MMM DD, YYYY"
                    )}
                  </p>
                  <div className="flex items-center gap-2">
                    <img className="w-5 h-5" src={clock} alt="clock" />
                    <p className="text-sm text-black">
                      {dateFormateForFareScreen(
                        state?.tripCheckout?.tripDetails?.scheduledTime ||
                          state?.tripCheckout?.scheduledTime,
                        "hh:mm a"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            )}
      
            {/* Car Type Section - Only if rideStatus */}
            {rideStatus && (
              <div className="pt-6 border-t border-dashed border-gray-300 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="flex items-center gap-2">
                  <img
                    src={tripData?.MasterCarType?.carImg}
                    alt="WhiteCar"
                    className="w-20 h-20"
                  />
                  <p className="ml-5">{tripData?.MasterCarType?.carType}</p>
                </div>
                <p className="text-gray-500 text-base">
                  We will assign your driver before 60min of your trip
                </p>
              </div>
            )}
      
            {/* Price Section */}
            <div className="pt-1 border-t border-dashed border-gray-300 flex items-center justify-between">
              <div className="flex flex-col gap-2">
                <h3 className="text-xl font-medium text-black">
                  {rideStatus ? "Total Fare" : "Estimation"}
                </h3>
                {params?.type !== tripEnumObject?.outStationRound && (
                  <p className="font-semibold text-gray-500">
                    Distance
                  </p>
                )}
              </div>
              <div className="flex flex-col items-end gap-2">
                <h3 className="text-xl font-semibold text-black">
                  {`₹ ` +
                    parseFloat(
                      tripPrice?.totalAmount ||
                        state?.tripCheckout?.amount ||
                        state?.tripCheckout?.price ||
                        0
                    )?.toFixed(2) || "0"}
                </h3>
                {!rideStatus && type !== tripEnumObject?.outStationRound && (
                  <p className="font-semibold text-gray-500">
                    {tripPrice?.distance ||
                      state?.tripCheckout?.tripDetails?.actualDistance}
                    km
                  </p>
                )}
              </div>
            </div>
      
            {/* Fare Breakdown for Outstation Round */}
            {/* {type === tripEnumObject?.outStationRound && (
              <div className="flex flex-col gap-3">
                {fareData(tripPrice)?.map((fare, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex flex-col gap-1">
                      <p className="text-black">{fare.heading}</p>
                      <p className="text-gray-500 text-sm">{fare.subHeading}</p>
                    </div>
                    <p className="text-black font-semibold">{"₹ " + fare?.amount}</p>
                  </div>
                ))}
              </div>
            )} */}
      
            <FareBreakUp tripDetails={tripPrice} type={type} />
      
            {/* Confirm Button - Only if not rideStatus */}
            {!rideStatus && (
              <div className="pt-6 border-t border-dashed border-gray-300">
                <div className="w-full">
                  <CommonForm
                    button={"Confirm"}
                    onSubmittBtn={onConfirmPayBtn}
                    loading={loading}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      );
      
}

export default ComfirmPay;
